import React from 'react'
import moment from 'moment'

import { List } from 'components'
import { Sale } from 'api/entity-schema'
import { buildListColumns } from 'lib/generator'

const fields = [
  'orderClosedDate',
  'artworkName',
  'productQuantity',
  'commission'
]

const options = {
  orderClosedDate: {
    buildCell: (v) => moment(v).format('MMM DD, YYYY')
  },
  commission: {
    buildCell: (v) => `£ ${v}`
  },
  vendorName: {
    grow: true
  }
}

const columns = buildListColumns(fields, options, Sale)

const SaleList = ({ data, ...rest }) => (
  <List
    data={data.map((e, i) => ({
      ...e,
      id: `${e.orderId}-${e.productSku}-${e.artworkId}`
    }))}
    columns={columns}
    plain
    {...rest}
  />
)

export default SaleList



// WEBPACK FOOTER //
// ./src/containers/Sales/SaleList.js